import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { Card, Badge, Table, Button } from 'react-bootstrap';
import classNames from 'classnames';
import ModalContext from './ModalContext';
import ApiService from '../../services/ApiService';
import Form from '../form/Form';
import '../../styles/repairstories.scss';

const ModalRepairStory = ({ lookupKey = '' }) => {
  const [data, setData] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [layout, setLayout] = useState([]);
  const { setTitle, close } = useContext(ModalContext);

  const title = `Repair Stories (${lookupKey})`;

  const getOperations = () => {
    ApiService.get(`repair/${encodeURIComponent(lookupKey)}/operations`).then(response => {
      setLayout([
        {
          name: 'repairId',
          hidden: true,
          data: lookupKey,
        },
        {
          name: 'technician',
          label: 'Technician',
          control: 'Search',
          validation: { list: { method: { name: 'REPAIRTECHLIST', key: 'repairId' } } },
          required: true,
          col: 6,
        },
        {
          name: 'operation',
          label: 'Operation',
          control: 'Select',
          // options: [1, 2, 3, 4, 5, 6, 7, 8, 9],
          options: response.data.operations,
          required: true,
          col: 6,
        },
        {
          name: 'cause',
          label: 'Cause',
          control: 'Textarea',
        },
        {
          name: 'correction',
          label: 'Correction',
          control: 'Textarea',
        },
      ]);
    });
  };

  const reset = () => {
    setTitle(title);
    setShowForm(false);
  };

  const getStories = () => {
    ApiService.get(`repair/${encodeURIComponent(lookupKey)}/stories`).then(response => {
      const { data } = response.data || [];
      setData(data);
      reset();
    });
  };

  const addStory = payload => {
    const params = {};

    payload.forEach(param => {
      params[param.name] = param.data;
    });

    return ApiService.put(`repair/${encodeURIComponent(lookupKey)}/story`, params);
  };

  const getTitle = () => {
    setTitle(
      <div className="modal-icon-title">
        <div className="icon-wrapper">
          <i className="zmdi zmdi-arrow-left" onClick={reset} />
        </div>
        <div className="title-wrapper">Add New Story</div>
      </div>
    );

    setShowForm(true);
  };

  useEffect(() => {
    getOperations();
    getStories();
    setTitle(`Repair Stories (${lookupKey})`);
  }, []);

  const renderTitle = () => {
    return (
      <p>
        Repair Stories <Badge>{data.length}</Badge>
      </p>
    );
  };

  const renderStories = () => {
    const stories = [];

    if (!data.length) {
      return (
        <div className="loading-wrapper">
          <div className="loading-child">Empty</div>
        </div>
      );
    }

    data.forEach((story, index) => {
      const style = {};

      stories.push(
        <tr key={`header-${index}`}>
          <td colSpan="2">
            <div className="dateline">{story.date}</div>
            <div className="story">
              {story.name} ({story.id})
            </div>
          </td>
        </tr>
      );

      stories.push(
        <tr key={index} style={style}>
          <td>
            <div className="cause">{story.cause || '<Empty>'}</div>
            <div className="correction">{story.correction || '<Empty>'}</div>
          </td>
          <td className="operation">{story.operation}</td>
        </tr>
      );
    });

    return (
      <Table>
        <tbody>{stories}</tbody>
      </Table>
    );
  };

  const entryClass = classNames('entry-panel', 'animated', {
    hidden: showForm,
    fadeIn: !showForm,
  });

  const resultClass = classNames('result-panel', 'animatedFast', {
    hidden: !showForm,
    slideInRight: showForm,
  });

  return (
    <div className="modal-repair-stories">
      <div className={entryClass}>
        <Card variant="secondary">
          <Card.Header>
            <Card.Title>{renderTitle()}</Card.Title>
          </Card.Header>
          <Card.Body>
          {renderStories()}
          </Card.Body>
        </Card>
        <div className="modal-lower-toolbar">
          <Button onClick={getTitle} variant="success">
            Add Story
          </Button>
          <Button onClick={close} variant="secondary">Close</Button>
        </div>
        <div className="clearfix" />
      </div>
      <div className={resultClass}>
        {!!layout.length && (
          <Form layout={layout} submit={addStory} submitCallback={getStories} feedback="none" hideCancel />
        )}
      </div>
    </div>
  );
};

ModalRepairStory.propTypes = {
  lookupKey: PropTypes.string,
};

export default ModalRepairStory;
